function readAvatarImage(file) {
  return new Promise((resolve, reject) => {
    const url = URL.createObjectURL(file);
    const image = new Image();
    image.onload = () => { URL.revokeObjectURL(url); resolve(image); };
    image.onerror = () => { URL.revokeObjectURL(url); reject(new Error('Fotoğraf açılamadı. JPG, PNG veya WebP biçiminde bir fotoğraf seç.')); };
    image.src = url;
  });
}
function prepareAvatar(file, readImage = readAvatarImage, createCanvas = () => document.createElement('canvas'), selection) {
  if (!file || file.size > 25 * 1024 * 1024) return Promise.reject(new Error('Fotoğraf en fazla 25 MB olabilir.'));
  return Promise.resolve().then(() => readImage(file)).then(image => {
  const width = image.naturalWidth || image.width;
  const height = image.naturalHeight || image.height;
  if (!(width > 0 && height > 0)) throw new Error('Fotoğrafın boyutları okunamadı.');
  const selected=selection?require('./avatarCrop').avatarCrop(width,height,selection):null;
  const crop = selected?selected.size:Math.min(width, height);
  const side = Math.max(1,Math.floor(Math.min(512, crop)));
  const canvas = createCanvas();
  canvas.width = side; canvas.height = side;
  const context = canvas.getContext('2d');
  if (!context) throw new Error('Fotoğraf hazırlanamadı.');
  context.fillStyle = '#ffffff';
  context.fillRect(0, 0, side, side);
  context.drawImage(image, selected?selected.left:(width - crop) / 2, selected?selected.top:(height - crop) / 2, crop, crop, 0, 0, side, side);
  return new Promise((resolve, reject) => canvas.toBlob(blob => blob ? resolve(blob) : reject(new Error('Fotoğraf hazırlanamadı.')), 'image/jpeg', 0.82));
  });
}
module.exports = { prepareAvatar, readAvatarImage };
